import { type FC } from 'react';

import { withFlags } from '@confluence/flags/entry-points/withFlags';
import { type FlagsStateContainer } from '@confluence/flags/entry-points/FlagsStateContainer';

import { useRealtimeAccessRequestsFlags } from './useRealtimeAccessRequestsFlags';

interface RealtimeAccessRequestsProps {
	contentType: string;
	contentId: string;
	flags: FlagsStateContainer;
	onReviewRequestsClick: () => void;
}

const RealtimeAccessRequestsInternal: FC<RealtimeAccessRequestsProps> = ({
	contentType,
	contentId,
	flags,
	onReviewRequestsClick,
}) => {
	useRealtimeAccessRequestsFlags({
		onReviewRequestsClick,
		contentId,
		contentType,
		flags,
	});

	return null;
};

export const RealtimeAccessRequests = withFlags(RealtimeAccessRequestsInternal);
